import API from './API.js';
export default class GetFaqs extends API {
    constructor() {
        super('faqs');
    }

}
